// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2IKbF","location":"Header_location__1fx7S"};